
import { EmailTemplateProps } from './types';

export const validateTemplateProps = (props: EmailTemplateProps): { isValid: boolean; errors: string[] } => {
  try {
    // Validate required properties based on template needs
    if (!props) {
      return { isValid: false, errors: ['Template props are required'] };
    }

    // Basic validation passed
    return { isValid: true, errors: [] };
  } catch (error: any) {
    return { 
      isValid: false, 
      errors: [error.message || 'Unknown validation error'] 
    };
  }
};

// This function is still used to sanitize props - kept for backward compatibility
export const sanitizeTemplateProps = (props: EmailTemplateProps) => {
  // Make sure we have valid props
  if (!props) {
    return { recipientName: 'User' }; // Provide default recipientName since it's required
  }
  
  // Return a clean, valid copy of the props
  return {
    recipientName: props.recipientName || 'User',
    pollData: props.pollData ? {
      title: props.pollData.title || '',
      description: props.pollData.description || '',
      results: props.pollData.results ? {
        totalVotes: props.pollData.results.totalVotes || 0,
        topOption: props.pollData.results.topOption || '',
        agreePercentage: props.pollData.results.agreePercentage
      } : undefined
    } : undefined,
    insightData: props.insightData ? {
      ...props.insightData,
      changes: props.insightData.changes || []
    } : undefined,
    notes: props.notes || '',
    // Include other properties
    credentials: props.credentials,
    loginData: props.loginData,
    resetUrl: props.resetUrl,
    verifyUrl: props.verifyUrl,
    reason: props.reason,
    changes: props.changes,
    countryCode: props.countryCode,
    countryName: props.countryName,
    formattedLaunchDate: props.formattedLaunchDate,
    baseUrl: props.baseUrl
  };
};

export default validateTemplateProps;
